import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { videoLegacyZeroDataSchema } from './data';

/**
 * Zero-block-placement legacy video envelope.
 *
 * `type: z.literal('zero')` is required here (no `.optional()`): a video
 * created inside a zero block must carry the tag end-to-end so that
 * downstream consumers (positioning effects, render branches) can recognise
 * the placement. The host-app factory copies `meta.type` onto the entity at
 * creation time; missing-tag entities are validation errors against this
 * branch by design.
 *
 * Inner data uses {@link videoLegacyZeroDataSchema} — the full extended-position
 * grid plus hide/animation/isSynchronizeStyle. This is a meaningful shape
 * divergence from the default variant, not just an envelope tag.
 */
export const videoLegacyZeroV0Schema = z.object({
    id: z.string(),
    name: z.literal('video'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().optional(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('zero'),
    data: videoLegacyZeroDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
